import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.25",
      d: "M52.556 59.813c1.451 0 2.419-.968 2.419-2.419V18.698c0-7.98-6.53-14.51-14.511-14.51H11.442c-1.451 0-2.419.967-2.419 2.418v50.788c0 1.451.968 2.419 2.419 2.419z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.25",
      d: "M39.35 4.188v12.436c0 1.913 1.275 3.189 3.188 3.189h12.437"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-width": "2.25",
      d: "M24.51 27.77a.625.625 0 1 1 0-1.25M24.51 27.77a.625.625 0 1 0 0-1.25M39.488 27.77a.625.625 0 0 1 0-1.25M39.488 27.77a.625.625 0 1 0 0-1.25"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-width": "2.25",
      d: "M20.64 44.106c1.573-4.769 6.065-8.21 11.36-8.21 5.296 0 9.787 3.441 11.36 8.21"
    }, null, -1)
  ])))
}
export default { render: render }